const tagRouterMap = [
  {
    path: "commonObjects/tagList",
    component: () => import("@/views/TagList/index.vue"),
    name: "标签列表",
  }
]

export default tagRouterMap
